<template>
  <article class="tile is-child box" v-if="service">
    <template v-if="parseInt($store.state.config.user.level) < 99">
      <div class="notification is-warning" v-if="service.changes || service.change">
        <template v-if="parseInt(service.changed) == 1 || parseInt(service.changed) == 2">
          <i class="fa fa-exclamation-triangle" style="font-size: 20px;"></i> This is the (ORIGINAL) booking of a SAVE. <a :href="url(service.changes.newservice.id)" target="_blank">{{service.changes.newservice.booking_id}}-{{service.changes.newservice.service_id}}</a>
        </template>
        <template v-else>
          <i class="fa fa-exclamation-triangle" style="font-size: 20px;"></i> This is the (SAVE) booking of the ORIGINAL. <a :href="url(service.change.oldservice.id)" target="_blank">{{service.change.oldservice.booking_id}}-{{service.change.oldservice.service_id}}</a>
        </template>
      </div>
    </template>
    <div class="notification is-info" v-if="related.length > 1">
      <i class="fa fa-info-circle" style="font-size: 20px;"></i> Related services:
      <template v-for="related_service in related">
        <a style="color: white;" :href="url(related_service.id)" target="_self" v-if="related_service.id != service.id">{{ parseInt(service.integration) === 1 ? related_service.service_id : related_service.api_service_id}}</a>&nbsp;
      </template>
    </div>
    <div class="columns">
      <div class="column is-2">
        <a class="button is-warning" @click="newOccurrence()">
          <span>New Ticket</span>
        </a>
      </div>
      <template v-if="parseInt($store.state.config.user.level) < 99">
        <template v-if="parseInt(service.integration) <= 2">
          <div class="column is-10"><h4 style="border: none;" class="title"><span class="is-pulled-right">{{ parseInt(service.integration) === 1 ? 'Cangooroo: ' + service.booking_id + '-' + service.service_id : 'EZ Connect: ' + service.api_booking_id + '-' + service.api_service_id}} ({{ service.status }}) {{ parseInt(service.integration) === 2 ? '/ ' + service.our_status: ''}}</span></h4></div>
        </template>
        <template v-else>
          <div class="column is-10"><h4 style="border: none;" class="title"><span class="is-pulled-right">Manual Service - {{service.id}} ({{ service.status }}) </span></h4></div>
        </template>
      </template>
      <template v-else>
        <div class="column is-10"><h4 style="border: none;" class="title"><span class="is-pulled-right">{{ parseInt(service.integration) === 1 ? 'Cangooroo: ' + service.booking_id + '-' + service.service_id : 'EZ Connect: ' + service.api_booking_id + '-' + service.api_service_id}} ({{ service.status }}) </span></h4></div>
      </template>
    </div>
    <div class="columns">
      <div class="column is-12"><h4 style="border: none;" class="title"><span class="is-pulled-right">Team User: {{ service.user !== null ? service.user.name : 'Not Allocated' }}</span></h4></div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="panel">
          <p class="panel-heading" style="justify-content: space-between;">Hotel
            <tooltip label="Refresh Service" type="default" placement="left" v-if="(parseInt($store.state.config.user.level) < 99)">
              <a class="button button-table is-small is-pulled-right" @click="refreshService()">
                <i class="fa fa-refresh"></i>
              </a>
            </tooltip>
          </p>
          <p class="panel-block">
            <i class="fa fa-bed"></i>
            {{ service.room.hotel.name + (parseInt($store.state.config.user.level) < 99 ? (service.room.hotel.chain_hotel ? ' ('+ service.room.hotel.chain_hotel.chain.name + ')' : '') : '')}}
          </p>
          <p class="panel-block">
            <i class="fa fa-th-list"></i>
            {{ service.room.description.substring(0,45) }}
            <template v-if="service.room.description.length > 45">
              <tooltip style="word-break: break-all;" :label="service.room.description" type="default" placement="right">
                <a class="is-small">
                  <i class="fa fa-eye"></i>
                </a>
              </tooltip>
            </template>
          </p>
          <p class="panel-block">
            <i class="fa fa-cutlery"></i>
            {{ service.room.board_description }}
          </p>
          <p class="panel-block">
            <i class="fa fa-calendar"></i>
            <b>{{ service.service_date | moment('YYYY-MM-DD') }}</b> to <b>{{ service.service_date | moment('add', service.room.number_nights + ' days', 'YYYY-MM-DD')}}</b>
          </p>
          <p class="panel-block">
            <i class="fa fa-user"></i> {{ service.paxes.length }}
          </p>
          <p class="panel-block" v-if="parseInt(service.integration) === 1">
            <i class="fa fa-group"></i>
            Adults: <b>{{ service.room.number_adults }}</b> Children: <b>{{ service.room.number_children }}</b>
          </p>
          <p class="panel-block">
            <i class="fa fa-moon-o"></i>
            {{ service.room.number_nights }}
          </p>
          <template v-if="parseInt($store.state.config.user.level) < 4">
            <p class="panel-block">
              <i class="fa fa-usd"></i>
              Client: <b>{{ this.salePrice() }}</b> Provider: <b>{{ service.room.provider_price}} {{service.room.provider_currency}}</b>
              <!-- <span v-if="service.base !== null && parseInt(service.base.is_markup) === 1"> Customer: <b>{{service.price}} {{service.currency}}</b></span> -->
            </p>
          </template>
          <template v-else>
            <p class="panel-block">
              <i class="fa fa-usd"></i>
              {{ service.price + " " + service.currency }}
            </p>
          </template>
          <p class="panel-heading">Hotel Info</p>
          <p class="panel-block">
            <i class="fa fa-globe"></i>
            <b>{{ service.room.hotel.city.name }}</b> - <span style="font-size: 12px;">({{ service.room.hotel.location }})</span>
          </p>
          <p class="panel-block">
            <i class="fa fa-map-marker"></i>
            {{ service.room.hotel.address }}
          </p>
          <template v-if="service.room.hotel_info.phone">
          <p class="panel-block" v-bind:value="'phone' + phone" v-for="phone in service.room.hotel_info.phone.split(',')">
            <i class="fa fa-phone"></i>
            <a :href="'tel:' + phone.replaceAll(',', '')">{{ phone.replaceAll(',', '') }}</a>
          </p>
          </template>
          <template v-if="service.room.hotel_info.email">
            <p class="panel-block">
              <i class="fa fa-envelope"></i>
              <a :href="'mailto:' + service.room.hotel_info.email">{{ service.room.hotel_info.email }}</a>
            </p>
          </template>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="panel panel-success">
          <p class="panel-heading panel-heading-success">Paxs</p>
          <p class="panel-block" v-for="pax in service.paxes">
            <i class="fa fa-user"></i>
            <template v-if="parseInt(service.integration) === 1">
            {{ pax.title }} . {{ pax.name }} {{ pax.last_name }} - AGE: {{ pax.age }}
            </template>
            <template v-else>
              {{ pax.name }} {{ pax.last_name }}<span v-if="pax.age > 0"> - AGE: {{ pax.age }}</span>
            </template>
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="panel">
          <p class="panel-heading">Cancellation</p>
          <template v-if="service.refundable !== null">
            <p class="panel-block">
              <i class="fa fa-ban"></i>
              <b>Refundable: </b> {{ service.refundable ? 'True' : 'False' }}
            </p>
          </template>
          <template v-if="parseInt($store.state.config.user.level) < 99">
            <p class="panel-block" v-for="cancellation in service.cancellations">
              <i class="fa fa-ban"></i>
              <b>From: </b> {{ cancellation.start_date | moment('YYYY-MM-DD hh:mm A') }}
              <b>To: </b>{{ cancellation.end_date | moment('YYYY-MM-DD hh:mm A') }}
              <b>Value: <span style="color: red;"> {{ parseFloat(cancellation.price).toFixed(2) }} {{cancellation.currency}}</span></b> -
              <b>{{ parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'}}</b>
            </p>
            <p class="panel-block" v-show="service.status === 'Cancelled'">
              <span>
                <i class="fa fa-ban"></i> <b>Cancelled:</b> {{ service.cancellation_date }}
              </span>
            </p>
          </template>
          <template v-else>
            <p class="panel-block" v-for="cancellation in service.cancellations" v-if="parseInt(cancellation.type) === 2">
              <i class="fa fa-ban"></i>
              <b>From: </b> {{ cancellation.start_date | moment('YYYY-MM-DD hh:mm A') }}
              <b>To: </b>{{ cancellation.end_date | moment('YYYY-MM-DD hh:mm A') }}
              <b>Value: <span style="color: red;"> {{ parseFloat(cancellation.price).toFixed(2) }} {{cancellation.currency}}</span></b> -
              <b>{{ parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'}}</b>
            </p>
          </template>
        </div>
      </div>
    </div>

      <div class="columns">
        <template v-if="parseInt($store.state.config.user.level) < 4">
          <div class="column is-half">
            <div class="panel panel-warning">
              <p class="panel-heading panel-heading-warning">Broker Info</p>
              <p class="panel-block">
                {{ service.room.provider.name }}
              </p>
              <p class="panel-block">
                <i class="fa fa-hashtag"></i>
                <template v-if="parseInt(service.integration) <= 2">
                  {{ parseInt(service.integration) === 1 ? service.room.provider_booking_code : (service.api_supplier_id !== service.room.provider_booking_code ? service.api_supplier_id + (service.room.provider_booking_code !== null ? '-' + service.room.provider_booking_code : '') : service.api_supplier_id) }}
                </template>
                  <template v-else>
                    {{ service.room.provider_booking_code }}
                  </template>
              </p>
              <p class="panel-block">
                <i class="fa fa-calendar"></i>
                {{ service.reservation_date }}
              </p>
            </div>
          </div>
        </template>
        <div class="column is-half">
          <div class="panel panel-warning">
            <p class="panel-heading panel-heading-warning">Customer Info</p>
            <!-- <p class="panel-block" v-if="service.base !== null">Base: <b>{{ service.base.name }}</b></p> -->
            <p class="panel-block">Agency: <b>{{ service.agency.name }}</b></p>
            <p class="panel-block">Client Ref:
              <a :href="url(booking)" target="_blank" v-if="service.agency.id === 25"><b>{{ service.client_ref }}</b></a>
              <b v-if="service.agency.id !== 25">{{ service.client_ref }}</b></p>
          </div>
        </div>
      </div>
    <template v-if="(parseInt($store.state.config.user.level) < 4)">
      <div class="panel" v-show="service.invoice || service.payment_order">
        <p class="panel-heading panel-heading-card">Finances</p>
        <!-- <a class="button is-success is-small" style="float:right;" @click="showNewCard()" v-if="((parseInt($store.state.config.user.level) < 4) && ((service.payment_order != null) && parseInt(service.payment_order.payment.payment) != 1) || (service.payment_order === null))">New Card</a> -->
        <p class="panel-block" v-if="parseInt(service.card_payment) === 1 && service.invoice">
          <b>Card:</b> XXXX XXXX XXXX {{service.card_client.last4}} - {{service.card_client.brand.toUpperCase()}} <b>Gateway:</b> {{service.card_client.type === 1 ? 'Stripe' : 'WorldPay'}}<br>
          <b>Value:</b> {{service.card_client.value}} {{service.card_client.currency}} <b>Installment:</b> {{service.card_client.installment}}X
        </p>
        <p class="panel-block" v-if="parseInt(service.card_payment) === 0 && service.invoice != null && ((service.status == 'Confirmed') || (service.status === 'PendingCancellation') || ((service.status === 'Cancelled') && ((new Date(service.service_date)).getTime() <= (new Date(service.cancellation_date).getTime()))) || parseInt(service.dispute) == 1 || parseInt(service.invoice.protected) == 1)">

        <template v-if="parseInt(service.invoice.invoice.payment) != 1">
          <tooltip :label="parseInt(service.invoice.protected) == 0 ? 'Protect' : 'Unprotect'" type="default" placement="left">
            <a class="button button-table is-small" @click="protectInvoice()">
              <i :class="{'fa': true, 'fa-lock': parseInt(service.invoice.protected) == 0, 'fa-unlock': parseInt(service.invoice.protected) == 1}"></i>
            </a>
          </tooltip>
        </template>

        <b>Invoice:</b> <a @click="openInvoice(true)">{{service.invoice.invoice_id}}</a><label v-if="parseInt(service.invoice.invoice.payment) == 1"><b>(Payed)</b> - {{service.invoice.invoice.deposit_date | moment('YYYY-MM-DD') }}</label> <label v-if="service.invoice.invoice.payment"><b>({{parsePreMethod(service.invoice.invoice.payment)}})</b></label></p>
        <p class="panel-block" v-if="service.payment_order != null && parseInt(service.payment_order.payment.payment_method_id) !== 36 && ((service.status == 'Confirmed') || (service.status === 'PendingCancellation') || (service.status === 'Cancelled') && ((new Date(service.service_date)).getTime() < (new Date(service.cancellation_date).getTime())) || parseInt(service.dispute) == 1 || parseInt(service.payment_order.protected) == 1)">

        <template v-if="parseInt(service.payment_order.payment.payment) != 1">
          <tooltip :label="parseInt(service.payment_order.protected) == 0 ? 'Protect' : 'Unprotect'" type="default" placement="left">
            <a class="button button-table is-small" @click="protectPayment()">
              <i :class="{'fa': true, 'fa-lock': parseInt(service.payment_order.protected) == 0, 'fa-unlock': parseInt(service.payment_order.protected) == 1}"></i>
            </a>
          </tooltip>
        </template>

        <b>Payment:</b> <a @click="openPayment()">{{service.payment_order.payment_id}}</a><label v-if="parseInt(service.payment_order.payment.payment) == 1"><b>(Payed)</b> - {{service.payment_order.payment.deposit_date | moment('YYYY-MM-DD')}}</label> <label v-if="service.payment_order.payment"><b>({{parsePreMethod(service.payment_order.payment.payment)}})</b></label></p>
        <p class="panel-block" v-if="parseInt(service.payment_type) === 'credit card'"><b>{{service.payment_last4}}</b><label>{{service.payment_description}}</label></p>
        <template v-if="service.card">
        <p class="panel-block" v-if="service.payment_type === 'credit card' && !newCard && service.payment_order"><b>Card: </b><label>{{service.payment_description}} - <b>Main:</b> #{{service.card.id}} - {{service.card.brand}} - {{service.card.card}} - {{service.card.bank}}</label></p>
        </template>
        <template v-else>
          <p class="panel-block" v-if="service.payment_type === 'credit card' && !newCard && service.payment_order"><b>Card: </b><label>{{service.payment_description}}</label></p>
        </template>
        <!-- <p class="panel-block" v-if="newCard">
          <card :service="service" :email="service.room.hotel_info.financial_email" v-on:reload="reload"></card>
        </p> -->
      </div>
      <finances v-if="(service.payment_services_v2 || service.invoice_services_v2)" :service="service"></finances>
    </template>
    <!-- CLIENT -->
    <template v-else>
      <div class="panel" v-show="service.invoice || service.payment_order">
        <p class="panel-heading">Finances</p>
        <p class="panel-block" v-if="parseInt(service.card_payment) === 1">
          <b>Card:</b> XXXX XXXX XXXX {{service.card[0].last4}} - {{service.card[0].brand.toUpperCase()}} <b>Gateway:</b> {{service.card[0].type === 1 ? 'Stripe' : 'WorldPay'}}<br>
          <b>Value:</b> {{service.card[0].value}} {{service.card[0].currency}} <b>Installment:</b> {{service.card[0].installment}}X
        </p>
        <p class="panel-block" v-if="parseInt(service.card_payment) === 0 && service.invoice != null && ((service.status == 'Confirmed') || (service.status === 'PendingCancellation') || ((service.status === 'Cancelled') && ((new Date(service.service_date)).getTime() <= (new Date(service.cancellation_date).getTime()))) || parseInt(service.dispute) == 1 || parseInt(service.invoice.protected) == 1)"><b>Invoice:</b> <a @click="openInvoice(false)">{{service.invoice.invoice_id}}</a> <label v-if="parseInt(service.invoice.invoice.payment) == 1"><b>(Payed)</b> - {{service.invoice.invoice.deposit_date | moment('YYYY-MM-DD') }}</label> <label v-if="service.invoice.invoice.payment"><b>({{parsePreMethod(service.invoice.invoice.payment)}})</b></label></p>
        <!-- <p class="panel-block" v-if="service.payment_type === 'credit card'"><b>{{service.payment_last4}}</b> - <label>{{service.payment_description}}</label></p> -->
      </div>
      <finances v-if="(service.invoice_services_v2)" :service="service"></finances>
    </template>
    <!-- CLIENT -->
    <template v-if="service.observation && service.observation !== ''">
      <div class="columns">
        <div class="column is-12">
          <div class="panel panel-info">
            <p class="panel-heading panel-heading-info">Observation</p>
            <p class="panel-block">
            <pre v-html="service.observation"></pre>
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-if="parseInt($store.state.config.user.level) < 4 && service.remarks && service.remarks !== ''">
      <div class="columns">
        <div class="column is-12">
          <div class="panel panel-info">
            <p class="panel-heading panel-heading-info">Remarks</p>
            <p class="panel-block">
            <pre v-html="service.remarks"></pre>
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-if="parseInt(service.internal_status) == 3 || (service.confirmation_datetime !== null && parseInt(service.internal_status) < 4)">
      <div class="columns">
        <div class="column is-12">
          <div class="panel panel-success">
            <p class="panel-heading panel-heading-success">Reconfirmation <a class="button is-primary is-small" style="float:right;" @click="reconfirmation()" v-if="(parseInt($store.state.config.user.level) < 4)">Reset Reconfirmation</a></p>
            <p class="panel-block"><i class="fa fa-user"></i> {{ service.confirmation_attendant }}</p>
            <p class="panel-block"><i class="fa fa-hashtag"></i> {{ service.confirmation_number }}</p>
            <p class="panel-block"><i class="fa fa-calendar"></i> {{ service.confirmation_datetime }}</p>
            <p class="panel-block" v-if="(parseInt($store.state.config.user.level) < 4)"><i class="fa fa-usd"></i> {{ parseInt(service.confirmation_payment) == 1 ? 'Payed' : 'Not Payed' }}</p>
            <p class="panel-block" v-if="(parseInt($store.state.config.user.level) < 4)">
              <reconfirm-email :service="service" v-on:reload="reload"></reconfirm-email>
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="columns" v-if="parseInt($store.state.config.user.level) < 99">
        <div class="column is-12">
          <div class="panel panel-success">
            <p class="panel-heading panel-heading-success">Reconfirmation</p>
            <p class="panel-block">
              <reconfirm :service="service" v-on:reload="reload"></reconfirm>
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-if="parseInt($store.state.config.user.level) < 99">
      <div class="columns">
        <div class="column is-12">
            <div class="panel panel-info">
              <p class="panel-heading panel-heading-info">Internal Tips</p>
              <p class="panel-block">
                <tips :service="service" v-on:reload="reloadHistory"></tips>
              </p>
            </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="panel">
            <p class="panel-heading" style="justify-content: space-between;">History
              <button class="button is-success is-small" @click="loadHistory()">Load history</button>
            </p>
            <p class="panel-block" v-if="load_history === 1" >
              <history :service="service"></history>
            </p>
          </div>
        </div>
      </div>
      <template v-if="parseInt(service.internal_status) == 4">
        <div class="columns">
          <div class="column is-12">
            <div class="panel panel-info">
              <p class="panel-heading panel-heading-info">Skip Information</p>
              <p class="panel-block">
              <pre>{{ service.skipped_information }}</pre>
              </p>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="parseInt(service.internal_status) < 3">
          <div class="columns">
            <div class="column is-12">
              <div class="panel panel-warning">
                <p class="panel-heading panel-heading-warning">Skip</p>
                <p class="panel-block">
                  <skip :service="service" v-on:reload="reload"></skip>
                </p>
              </div>
            </div>
          </div>
        </template>
      </template>
    </template>
  </article>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  import Reconfirm from './Reconfirm.vue'
  import ReconfirmEmail from './ReconfirmEmail.vue'
  import Skip from './Skip.vue'
  import Tips from './Tips.vue'
  import History from './History.vue'
  import HistoryOld from './HistoryOld.vue'
  import Invoice from '../finances/invoice'
  import Payment from '../finances/payment'
  import Occurrence from '../occurrences/occurrence'
  import Card from './Card.vue'
  import Finances from './V2/Finances.vue'
  export default {
    data () {
      return {
        service_history: null,
        load_service_old_history: false,
        reload_history: false,
        related: [],
        newCard: false,
        load_history: 0,
        booking: ''
      }
    },
    props: {
      service: {
        type: Object,
        default: null
      }
    },
    components: {
      Reconfirm,
      ReconfirmEmail,
      Skip,
      Tips,
      History,
      HistoryOld,
      Tooltip,
      Card,
      Finances
    },
    created () {
      if (this.service.agency.id === 25) {
        this.$http.post(this.$store.state.config.apiURL + '/services/original', { id: this.service.id }).then((response) => {
          this.booking = response.body
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    watch: {
      '$route' (to, from) {
        window.location.reload()
      }
    },
    methods: {
      refreshService () {
        if (window.confirm('Are you sure you want to Refresh the booking ' + this.service.api_booking_id + '-' + this.service.api_service_id + '?')) {
          let service = ''
          if (parseInt(this.service.integration) === 1) {
            service = this.service.service_id
          } else {
            service = this.service.api_service_id
          }
          this.$http.post(this.$store.state.config.apiURL + '/services/refresh', { booking_id: this.service.id }).then((response) => {
            this.message('success', 'Success', 'The service ' + service + ' was successfully refresh')
            setTimeout(() => window.location.reload(), 240000)
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      // showNewCard () {
      //   this.newCard = true
      // },
      parsePreMethod (method) {
        let payment = ''
        switch (parseInt(method)) {
          case 0: {
            payment = 'Unpaid'
            break
          }
          case 1: {
            payment = 'Paid'
            break
          }
          case 2: {
            payment = 'Sent'
            break
          }
          case 3: {
            payment = 'Confirmed Receipt'
            break
          }
          case 4: {
            payment = 'Billed'
            break
          }
        }
        return payment
      },
      newOccurrence () {
        let propsData = {
          context: this,
          booking: parseInt(this.service.integration) === 1 ? parseInt(this.service.booking_id) : parseInt(this.service.integration) === 2 ? parseInt(this.service.api_booking_id) : 'Manual',
          service: parseInt(this.service.integration) === 1 ? parseInt(this.service.service_id) : parseInt(this.service.integration) === 2 ? parseInt(this.service.api_service_id) : parseInt(this.service.id),
          integration: parseInt(this.service.integration),
          internal: parseInt(this.$store.state.config.user.level) < 99,
          generic: false,
          disabled: true,
          callback: 'openOccurrence'
        }
        Occurrence.openNewOccurrence(propsData)
      },
      openOccurrence (result) {
        if (result.ok) {
          this.message('success', 'Success', 'The occurrence ' + result.occurrence.id + ' was successfully registered')
          // this.$parent.$children[1].loadData()
          window.location.reload()
        } else {
          this.message('danger', 'Error', result.message)
        }
      },
      openInvoice (edit) {
        let propsData = {
          context: this,
          invoice_id: this.service.invoice.invoice_id,
          edit: edit,
          callback: ''
        }
        Invoice.openInvoice(propsData)
      },
      openPayment () {
        let propsData = {
          context: this,
          payment_id: this.service.payment_order.payment_id,
          edit: true,
          callback: ''
        }
        Payment.openPayment(propsData)
      },
      protectInvoice () {
        this.$http.post(this.$store.state.config.apiURL + '/invoice/protect', {invoices: [this.service.invoice.invoice_id]}).then((response) => {
          let propsData = {
            title: 'Success',
            message: 'The invoice protection has been applied',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }

          message.openMessage(propsData)
          this.reload()
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      protectPayment () {
        this.$http.post(this.$store.state.config.apiURL + '/payment/protect', {payments: [this.service.payment_order.payment_id]}).then((response) => {
          let propsData = {
            title: 'Success',
            message: 'The payment protection has been applied',
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
          this.reload()
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      url (service) {
        return '#/services/service/' + service
      },
      loadData () {
        this.$http.get(this.$store.state.config.apiURL + '/services/related/' + this.service.id).then((response) => {
          this.related = response.body
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      reload () {
        this.loadData()
        this.reloadHistory()
        this.newCard = false
      },
      salePrice () {
        // if (this.service.base !== null) {
        //   if (parseInt(this.service.base.is_markup) === 1) {
        //     return (((parseFloat(this.service.room.provider_price) / ((100 - this.service.base.markup) / 100) + parseFloat(this.service.base.bf)).toFixed(2) + ' ' + this.service.room.provider_currency))
        //   }
        // }
        return this.service.price + ' ' + this.service.currency
      },
      view (id) {
        this.$router.replace({name: 'Service', params: {id: id}})
      },
      loadHistory () {
        this.reloadHistory()
        this.load_history = 1
        return this.load_history
      },
      reloadHistory () {
        this.reload_history = !this.reload_history
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      loadOldHistory () {
        this.load_service_old_history = true
      },
      reconfirmation () {
        if (window.confirm('Are you sure you want to revert confirmation?')) {
          this.$http.post(this.$store.state.config.apiURL + '/services/resetReconfirmation', {service_id: this.service.id}).then((response) => {
            this.reload()
            this.message('success', 'Success', 'Confirmation has been reverted')
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      parsePayment (content) {
        let payment = ''
        switch (parseInt(content)) {
          case 0: {
            payment = 'Unpaid'
            break
          }
          case 1: {
            payment = 'Paid'
            break
          }
          case 2: {
            payment = 'Sent'
            break
          }
          case 3: {
            payment = 'Confirmed Receipt'
            break
          }
          case 4: {
            payment = 'Billed'
            break
          }
          case 5: {
            payment = 'Pending'
            break
          }
        }
        return payment
      }
    },
    filters: {
      truncate: function (string, value) {
        return string.substring(0, value) + '...'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-success {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(35, 209, 96), 0px 0px 0px 1px rgb(35, 209, 96);
    color: #23d160;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-success {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(35, 209, 96), 0px 0px 0px 0px rgb(35, 209, 96);
    background-color: rgb(35, 209, 96);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-heading-card {
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-info {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
    color: #3273dc;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-info {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(50, 115, 220), 0px 0px 0px 0px rgb(50, 115, 220);
    background-color: rgb(50, 115, 220);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-warning {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(255, 221, 87), 0px 0px 0px 1px rgb(255, 221, 87);
    color: #ffdd57;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-warning {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(255, 221, 87), 0px 0px 0px 0px rgb(255, 221, 87);
    background-color: rgb(255, 221, 87);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  pre {
    background-color: #FFFFFF;
    white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// Service.vue?88d26dcc